import React, { useState, useEffect } from 'react';
import '../styles/About.css';

const About = () => {
  const calculate_age = () => {
    var today = new Date();
    var birthDate = new Date("2005-12-17");
    var age_now = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age_now--;
    }
    return age_now;
  };

  const [imageUrl, setImageUrl] = useState("https://spotify-github-profile.kittinanx.com/api/view.svg?uid=31hgv3hncqa5p4qme3hi7ll7nyeu&cover_image=true&theme=default&show_offline=true&background_color=232135&interchange=true&bar_color_cover=false");

  useEffect(() => {
    const interval = setInterval(() => {
      setImageUrl(imageUrl + "?timestamp=" + new Date().getTime());
    }, 5000);
    return () => clearInterval(interval);
  }, [imageUrl]);

  return (
    <div className='about' id="about">
      <h2>Get To Know Me</h2>
      <hr></hr>
      <div className="words">
        <h3>Hello✨</h3>
        <p>
          I am Kunal from 📍 Maharashtra India 🇮🇳. Currently I am {calculate_age()} years Old 🐣
          <br></br>Done with my highschool and currently pursuing Bachelors in Computer Applications and in First Year of it 👨‍💻.
          <br></br>I am currently learning C++ and Web Developement.
          <br></br>I am a big fan of Anime #otaku 🐉. I love to play video games 🎮.
          <br></br>I have interest in Cyber Security 🔒 and Ethical Hacking 🔑 too, and goal is to learn linux 🐧 for that.
          <br></br>computers 💻 are my passion ❤ and I love to learn new things about them 😀.
          <br></br><br></br>My inspirations are Satya Nadela, Elon Musk, Sundar Pichai. I love to watch their interviews and speeches 🗣.
          <br></br>if you are reading this first time and haven't saw my GitHub 😸, then you should check that out too.
          <br></br>Give a star ⭐ to my repositories if you like them 😊.
          <br></br>Atlast, Life is short, so enjoy it 😎 and keep Learning new things 💗.
        </p>
        <h3>Thank you for Reading 🤝</h3>
      </div>
      <div className="spotifystatusabout" align="center">
        <a href="https://spotify-github-profile.kittinanx.com/api/view.svg?uid=31hgv3hncqa5p4qme3hi7ll7nyeu&redirect=true">
          <img src={imageUrl} alt="Spotify status" />
        </a>
      </div>
      <hr></hr>
    </div>
  );
};

export default About;
